<template>
  <vf-header v-if="!$feature.tempVansNewNav.value" />
  <lazy-vf-header-new v-else />
</template>

<script lang="ts" setup>
const VfHeader = defineAsyncComponent(() => import('#brand/components/vf/header/Header.vue'))
</script>
